<script setup lang="ts">
/**
 * One placeholder bar. Rendered wherever a value is still being read, in the exact box the
 * value will occupy, so nothing moves when the data arrives. Static by the motion law (no pulse). Decorative: hidden from readers.
 * Width and height are CSS lengths; the default height is one line of meta text.
 */
withDefaults(defineProps<{ width?: string; height?: string }>(), { width: '100%', height: 'var(--skeleton-line)' })
</script>

<template>
  <span aria-hidden="true" class="block max-w-full shrink-0 rounded-[var(--radius-label)] bg-muted" :style="{ width, height }" />
</template>
